import { render, staticRenderFns } from "./SearchIcon.vue?vue&type=template&id=3a023a8e&scoped=true&"
import script from "./SearchIcon.vue?vue&type=script&lang=ts&"
export * from "./SearchIcon.vue?vue&type=script&lang=ts&"
import style0 from "./SearchIcon.vue?vue&type=style&index=0&id=3a023a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a023a8e",
  null
  
)

export default component.exports